'use client';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';
import { LinkProps } from '@repo/ui/src/types/link';

interface Props {
  youtubeLink?: YoutubeLinkProps;
  youtubestring?: string;
  link?: LinkProps;
  cta?: Array<LinkProps>;
}

const SecondaryCta = ({ youtubeLink, youtubestring, link, cta: ctas }: Props) => {
  const { push } = useModal(ModalID.video);
  return (
    <div>
      {youtubeLink && youtubestring && (
        <div className="tw-mx-3">
          <Button variant={ButtonVariant.primary} onClick={() => push({ youtubeLink })}>
            {youtubestring}
          </Button>
        </div>
      )}
      {!youtubeLink && link && (
        <Button as={Anchor} variant={ButtonVariant.primary} className="sm:tw-my-10" {...link}>
          {link?.displayName}
        </Button>
      )}
      {ctas?.map((cta, i) => (
        <Button
          as={Anchor}
          variant={ButtonVariant.primary}
          className="sm:tw-my-10"
          {...cta}
          key={i}
        >
          {cta?.displayName}
        </Button>
      ))}
    </div>
  );
};

export default SecondaryCta;
